module.exports = __webpack_public_path__ + "static/media/Frankie.e8989ead.jpg";